// Surface card. Subtle inset highlight, no heavy shadow.
export default function Card({ title, action, children, className = "", testId }) {
    return (
        <section
            data-testid={testId}
            className={[
                "bg-ux-bg-1 border border-ux-border-1 rounded-lg p-5",
                "shadow-[inset_0_1px_0_rgba(255,255,255,0.02)]",
                className,
            ].join(" ")}
        >
            {(title || action) && (
                <div className="flex items-center justify-between mb-4">
                    {title && <h2 className="label-mini">{title}</h2>}
                    {action}
                </div>
            )}
            {children}
        </section>
    );
}
